import React from 'react';
import ProjectList from '../ProjectList';

function Portfolio(props) {
//   const { currentProject } = props;
  return (
    <section>
      {/* <h1 data-testid="h1tag">{capitalizeFirstLetter(currentProject.name)}</h1> */}
      {/* <p>{currentProject.description}</p> */}
      {/* <ProjectList name={currentProject.name} /> */}
      <ProjectList  />
    </section>
  );
}
export default Portfolio;